__turbopack_context__.v({
  "iframe": "M6iTyG_iframe",
  "iframeWrapper": "M6iTyG_iframeWrapper",
  "video": "M6iTyG_video",
  "videoWrapper": "M6iTyG_videoWrapper",
});
